import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class GetRegions {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * GetRegions constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Get available canvasser regions from API.
     *
     * @return {Promise}
     */
    handle() {
        return this.apiService.get(ApiEndpoints['canvassers.regions.index']);
    }
}
